import { Capped, capList } from './attention-view.logic';

/**
 * "+N more" that opens the full list (Bug 34839, Tim 2026-09-29: the footers were dead
 * text). A card is either capped to what fits, or expanded to every row, which then
 * scrolls inside the card. Pure; the component keeps the set of expanded card keys.
 */
export interface ExpandableList<T> extends Capped<T> {
  expanded: boolean;
  total: number;
  /** The footer control's text, or null when there is nothing to expand or collapse. */
  toggleText: string | null;
}

export function capOrAll<T>(
  items: T[],
  cap: number,
  expanded: boolean
): ExpandableList<T> {
  const total = items.length;
  if (expanded) {
    return {
      rows: items,
      more: 0,
      expanded: true,
      total,
      toggleText: total > cap ? 'Show less' : null,
    };
  }
  const capped = capList(items, cap);
  return {
    ...capped,
    expanded: false,
    total,
    toggleText: capped.more > 0 ? `+${capped.more} more` : null,
  };
}

/** Adds or removes `key`, returning a new set so a signal sees the change. */
export function toggleKey<K>(set: ReadonlySet<K>, key: K): ReadonlySet<K> {
  const next = new Set(set);
  if (next.has(key)) next.delete(key);
  else next.add(key);
  return next;
}
